<ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="modalController.dismiss()">
          <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
        </ion-button>
      </ion-buttons>
        <ion-title>Error Log</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item *ngFor="let err of errorsLogged" (click)="emailError(err)">
            <ion-label class="ion-text-wrap" *ngIf="err.stackFrames && err.stackFrames.length > 0">
                <p>{{err.date | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
                <p>{{err.message}}</p>
                <p *ngIf="err.stackFrames && err.stackFrames.length > 0">{{err.stackFrames[0].fileName}}</p>
                <p>{{err.stackFrames[0].functionName}} - line: {{err.stackFrames[0].lineNumber}}</p>
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>
